class ConsentBanner extends HTMLElement {
  constructor() {
    super();
    this.active = window.Shopify?.customerPrivacy?.getTrackingConsent() === 'no_interaction';
    this.form = this.querySelector('form');
    this.openPreferences = this.querySelectorAll('[data-open-preferences]');
    this.hidePreferences = this.querySelectorAll('[data-hide-preferences]');
    this.popUp = this.querySelector('dialog');
    this.actionMap = {
      'accept-all': {
        preferences: true,
        marketing: true,
        analytics: true,
      },
      'accept-essential': {
        preferences: false,
        marketing: false,
        analytics: false,
      },
      custom: {},
    };
    this.customerSelection = {};
    this.action = 'custom';
  }

  connectedCallback() {
    this.form = this.querySelector('form');

    // Listen for clicks on links that trigger the consent banner to reappear
    document.addEventListener('click', (e) => {
      const target = e.target;
      if (target.href && target.href.includes('#shopifyReshowConsentBanner')) {
        e.preventDefault();
        this.openPreferencesWithoutBanner();
      }
    });

    if (!this.form || !this.active) return;

    this.init();
    this.addEventListeners();
  }

  init() {
    if (window.Shopify.designMode) {
      return;
    }
    setTimeout(() => {
      this.setAttribute('data-active', 'true');
    }, 1000);
  }

  openPreferencesWithoutBanner() {
    this.setAttribute('data-active', '');
    this.setAttribute('data-pop-up-active', '');
    this.setAttribute('data-preferences-only', '');
    this.popUp?.showModal();
    this.fetchAndApplyCustomerPreferences();
    this.addEventListeners();
  }

  fetchAndApplyCustomerPreferences() {
    const currentVisitorConsent = window.Shopify?.customerPrivacy?.currentVisitorConsent();
    if (currentVisitorConsent) {
      this.customerSelection = {
        preferences: currentVisitorConsent.preferences == 'yes',
        marketing: currentVisitorConsent.marketing == 'yes',
        analytics: currentVisitorConsent.analytics == 'yes',
      };
    }
    // Set the checkboxes based on the current visitor consent
    Object.keys(this.customerSelection).forEach((key) => {
      const checkbox = this.querySelector(`input[name="${key}"]`);
      if (checkbox) {
        checkbox.checked = this.customerSelection[key];
      }
    });
  }

  addEventListeners() {
    this.openPreferences?.forEach((button) => {
      button.addEventListener('click', () => {
        this.setAttribute('data-pop-up-active', '');
        this.popUp?.showModal();
      });
    });

    this.hidePreferences?.forEach((button) => {
      button.addEventListener('click', () => {
        this.popUp?.close();

        // If only preferences is opened, hide the entire component
        if (this.hasAttribute('data-preferences-only')) {
          this.removeAttribute('data-active');
        }
      });
    });

    this.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitter = e.submitter;
      this.action = submitter?.dataset.action ?? 'custom';

      this.getCustomerSelection();
      this.setCustomerPreferences();
    });

    this.popUp?.addEventListener('close', () => {
      this.removeAttribute('data-pop-up-active');
      if (this.hasAttribute('data-preferences-only')) {
        this.removeAttribute('data-active');
      }
    });
  }

  getCustomerSelection() {
    const prefs = this.actionMap[this.action];

    // Initialize customer selection with required preferences
    if (this.action !== 'custom') {
      Object.keys(prefs).forEach((key) => {
        const checkbox = this.querySelector(`input[name="${key}"]`);
        if (checkbox) {
          // Check the checkbox based on the action preferences
          checkbox.checked = prefs[key];
          this.customerSelection[key] = checkbox.checked;
        }
      });
    }

    // Gather the user selection from checkboxes
    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      if (checkbox.disabled) return;
      this.customerSelection[checkbox.name] = checkbox.checked;
    });

    this.customerSelection = {
      ...this.customerSelection,
      ...prefs,
    };
  }

  hideConsentBanner() {
    this.removeAttribute('data-active');
    this.popUp?.close();
  }

  setCustomerPreferences() {
    window.Shopify?.customerPrivacy?.setTrackingConsent(this.customerSelection, () => {
      this.hideConsentBanner();
    });
  }
}

window.Shopify.loadFeatures(
  [
    {
      name: 'consent-tracking-api',
      version: '0.1',
    },
  ],
  (error) => {
    if (error) {
      throw error;
    }
    customElements.define('consent-banner', ConsentBanner);
  },
);

// Add the consentBanner object to the window for global access
window.consentBanner = {
  showConsentPreferences: function () {
    const consentBanner = document.querySelector('consent-banner');
    if (consentBanner) {
      consentBanner.openPreferencesWithoutBanner();
    }
  },
};
